import { Injectable } from '@angular/core';
import { GeometricFormQuery } from '../../state/geometric-form.query';
import { GeometricFormType } from '../../state/geometric-form.type';
import { BuildingBorder } from './building-border.model';
import { BuildingBorderStore } from './building-border.store';

@Injectable({ providedIn: 'root' })
export class BuildingBorderQuery extends GeometricFormQuery<BuildingBorder> {

  type: GeometricFormType = 'mitra-building-border';
  isLoading$ = this.selectLoading();

  constructor(protected store: BuildingBorderStore) {
    super(store);
  }

}
